module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-taiguo.22ab0df4.mp4";